import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, isRef as _isRef, createVNode as _createVNode, renderSlot as _renderSlot, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }

import { useFieldModel } from '@src/components/shared/form_fields/useFieldModel';
import TextFormInput from '@src/components/shared/form_elements/TextFormInput.vue';
import { computed, useSlots } from 'vue';
import FieldContainer from '@src/components/patterns/FieldContainer.vue';
import { useValueEqualsPlaceholderWarning } from '@src/components/shared/composables/useValueEqualsPlaceholderWarning';
import { useAriaDescribedby } from '@src/components/shared/composables/useAriaDescribedby';
import { useI18n } from 'vue-i18n';

interface Props {
	inputType?: 'text' | 'textarea';
	label: String;
	labelHelpText?: String;
	helpText?: String;
	name: string;
	inputId: string;
	placeholder: string;
	placeholderWarning?: string;
	modelValue: string | number;
	errorMessage: String;
	showError: boolean;
	disabled?: boolean;
	autocomplete?: string;
	autofocus?: boolean;
	isMaxWidthField?: boolean;
	ariaDescribedby?: string | undefined;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TextField',
  props: {
    inputType: { default: 'text' },
    label: {},
    labelHelpText: {},
    helpText: {},
    name: {},
    inputId: {},
    placeholder: {},
    placeholderWarning: {},
    modelValue: {},
    errorMessage: {},
    showError: { type: Boolean },
    disabled: { type: Boolean, default: false },
    autocomplete: { default: 'on' },
    autofocus: { type: Boolean },
    isMaxWidthField: { type: Boolean },
    ariaDescribedby: {}
  },
  emits: [ 'update:modelValue', 'field-changed' ],
  setup(__props: any, { emit: __emit }) {


const props = __props;
const emit = __emit;
const slots = useSlots();
const { t } = useI18n();

const fieldModel = useFieldModel<string | number>( () => props.modelValue, props.modelValue );
const valueEqualsPlaceholderWarning = useValueEqualsPlaceholderWarning( fieldModel, props.placeholder, props.placeholderWarning );
const ariaDescribedby = useAriaDescribedby(
	props.inputId,
	computed<boolean>( () => !!props.helpText ),
	computed<boolean>( () => props.showError ),
	computed<boolean>( () => valueEqualsPlaceholderWarning.hasWarning.value || !!slots.message ),
	computed<string | undefined>( () => props.ariaDescribedby )
);

const placeholderText = computed( (): string => {
	if ( props.placeholder ) {
		return t( 'form_for_example', { example: props.placeholder } );
	}
	return '';
} );

const onInput = (): void => {
	if ( props.showError ) {
		emit( 'field-changed', props.name );
	}
};

const onUpdateModel = ( newValue: string | number ): void => {
	emit( 'update:modelValue', newValue );
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(FieldContainer, {
    "input-id": __props.inputId,
    "show-error": __props.showError,
    "is-max-width-field": __props.isMaxWidthField
  }, _createSlots({
    label: _withCtx(() => [
      _createTextVNode(_toDisplayString(__props.label) + " ", 1),
      (__props.labelHelpText)
        ? (_openBlock(), _createElementBlock("em", _hoisted_1, _toDisplayString(__props.labelHelpText), 1))
        : _createCommentVNode("", true)
    ]),
    field: _withCtx(() => [
      _createVNode(TextFormInput, {
        name: __props.name,
        "input-type": __props.inputType,
        modelValue: _unref(fieldModel),
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => (_isRef(fieldModel) ? (fieldModel).value = $event : null)),
          onUpdateModel
        ],
        "input-id": __props.inputId,
        "has-error": __props.showError,
        "has-message": false,
        placeholder: placeholderText.value,
        autocomplete: __props.autocomplete,
        disabled: __props.disabled,
        autofocus: __props.autofocus,
        "aria-describedby": _unref(ariaDescribedby),
        onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('field-changed', __props.name ))),
        onInput: onInput
      }, null, 8, ["name", "input-type", "modelValue", "input-id", "has-error", "placeholder", "autocomplete", "disabled", "autofocus", "aria-describedby"])
    ]),
    error: _withCtx(() => [
      _createTextVNode(_toDisplayString(__props.errorMessage), 1)
    ]),
    _: 2
  }, [
    (__props.helpText)
      ? {
          name: "help-text",
          fn: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.helpText), 1)
          ]),
          key: "0"
        }
      : undefined,
    (_unref(valueEqualsPlaceholderWarning).hasWarning.value)
      ? {
          name: "message",
          fn: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(valueEqualsPlaceholderWarning).warning), 1)
          ]),
          key: "1"
        }
      : (_ctx.$slots.message)
        ? {
            name: "message",
            fn: _withCtx(() => [
              _renderSlot(_ctx.$slots, "message")
            ]),
            key: "2"
          }
        : undefined
  ]), 1032, ["input-id", "show-error", "is-max-width-field"]))
}
}

})